// These are the same as https://github.com/petergok/tempo-api/blob/8b4c758b8eb5b434c7287a69182f05dd49fa9e6a/src/utils/supabaseUtils.tsx#L137-L172
/**
 * Given a string and a compactDiff, apply the redo
 */
export const applyUndo = (currString: string, diff: any[]) => {
  const newContentBuilder: any = [];
  let currIndex = 0;
  const diffCopy = [...diff]; // hack to get around strict mode
  diffCopy.forEach((el) => {
    if (typeof el == "number") {
      newContentBuilder.push(currString.slice(currIndex, currIndex + el));
      currIndex += el;
    } else if (el[0] == 1) {
      currIndex += el[1].length;
    } else {
      newContentBuilder.push(el[1]);
    }
  });
  return newContentBuilder.join("");
};

/**
 * Given a string and a compactDiff, apply the redo
 */
export const applyRedo = (currString: string, diff: any[]) => {
  const newContentBuilder: any = [];
  let currIndex = 0;
  const diffCopy = [...diff]; // hack to get around strict mode
  diffCopy.forEach((el) => {
    if (typeof el == "number") {
      newContentBuilder.push(currString.slice(currIndex, currIndex + el));
      currIndex += el;
    } else if (el[0] == -1) {
      currIndex += el[1].length;
    } else {
      newContentBuilder.push(el[1]);
    }
  });
  return newContentBuilder.join("");
};

// maybe we don't need this util function, but makes ActivityStreamWrapper more readable imo
export const getLatestValidUuid = (data) => {
  return data.find((el) => el.is_active_change).id;
};
